export default __webpack_public_path__ + "static/media/TrainingVideos_Icon.6e09de58.png";